import React from 'react';
import { format } from 'date-fns';

interface CandlestickCellProps {
  open_time: number;
  close_time: number;
  blackMode?: boolean;
}

const CandlestickCell: React.FC<CandlestickCellProps> = ({ open_time, close_time, blackMode = false }) => {
  const openDate = new Date(open_time);
  const closeDate = new Date(close_time);
  
  // Formatear fechas específicas
  const formattedOpenDate = format(openDate, "MMM. do, HH:mm:ss");
  const formattedCloseDate = format(closeDate, "MMM. do, HH:mm:ss");
  
  // Obtener timezone local
  const timezoneOffset = openDate.getTimezoneOffset();
  const timezoneHours = Math.abs(Math.floor(timezoneOffset / 60));
  const timezoneMinutes = Math.abs(timezoneOffset % 60);
  const timezoneSign = timezoneOffset > 0 ? '-' : '+';
  const timezoneString = `(GMT ${timezoneSign}${timezoneHours.toString().padStart(2, '0')}:${timezoneMinutes.toString().padStart(2, '0')})`;

  const textColorClass = blackMode ? 'text-black' : 'text-gray-900';
  const secondaryTextColorClass = blackMode ? 'text-violet-400' : 'text-gray-400';

  return (
    <div className={`text-sm ${textColorClass}`}>
      <div className={`text-xs ${secondaryTextColorClass}`}>{formattedOpenDate} {timezoneString}</div>
      <div className={`text-xs ${secondaryTextColorClass}`}>{formattedCloseDate} {timezoneString}</div>
    </div>
  );
};

export default CandlestickCell;